import { useTranslation } from 'react-i18next';

import { Switch } from '@/components/ui/switch';

interface RecordExpenseSaveOptionsProps {
  addAnother: boolean;
  onAddAnotherChange: (addAnother: boolean) => void;
  disabled?: boolean;
}

export const RecordExpenseSaveOptions = ({
  addAnother,
  onAddAnotherChange,
  disabled = false,
}: RecordExpenseSaveOptionsProps) => {
  const { t } = useTranslation('spending');

  return (
    <div className="space-y-3 rounded-lg border p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <p className="text-sm font-medium">{t('expenses.saveOptions.addAnother')}</p>
          <p className="text-xs text-fg-secondary">{t('expenses.saveOptions.addAnotherHint')}</p>
        </div>
        <Switch
          id="record-expense-add-another"
          checked={addAnother}
          onCheckedChange={onAddAnotherChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
